package pwgs.ui.scenes.leaderboardlistscene

import kotlinx.serialization.Serializable
import pwgs.ui.scenes.custompropertieseditorscene.ECustomFieldType
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption
import visage.rmi.VisageController

@VisageController(LeaderboardListSceneProps::class, LeaderboardListSceneModel::class)
interface ILeaderboardList {
    fun load()
    fun showCreateDialog()
    fun create()
    fun delete(name: String)
}

@Serializable
class LeaderboardListSceneProps(val projectId: Long)

@Serializable
class LeaderboardListSceneModel(
    val leaderboards: List<LeaderboardListItemModel>
) {
    var isLoading: Boolean = true
    var createLeaderboardDialogModel: CreateLeaderboardDialogModel? = null
}

@Serializable
class LeaderboardListItemModel(
    val name: String,
    val linkedField: String,
    val sortOrder: ESortOrder,
    val clientChangeable: Boolean
)

@Serializable
class CreateLeaderboardDialogModel(
    val linkedFieldModel: MetaFieldModel<String, List<SelectOption>>
) {
    var isLoading: Boolean = false
    var error: String? = null
    val nameFieldModel = FieldModel("")
    val sortOrderField = MetaFieldModel(ESortOrder.Desc.name, listOf(
        SelectOption(ESortOrder.Asc.name, "Ascending"),
        SelectOption(ESortOrder.Desc.name, "Descending"),
    ))
    val clientChangeableField = MetaFieldModel("true", listOf(
        SelectOption("true", "Yes"),
        SelectOption("false", "No"),
    ))
}

@Serializable
enum class ESortOrder {
    Asc,
    Desc
}